import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, User, Calendar } from 'lucide-react';
interface PreQuizScreenProps {
  onContinue: (gender: string, age: string) => void;
}
const GENDER_OPTIONS = [{
  label: 'Mujer',
  value: 'mujer',
  emoji: '👩'
}, {
  label: 'Hombre',
  value: 'hombre',
  emoji: '👨'
}, {
  label: 'Prefiero no decir',
  value: 'no_decir',
  emoji: '🙂'
}];
const AGE_RANGES = ['18-24', '25-34', '35-44', '45-54', '55+'];
export function PreQuizScreen({
  onContinue
}: PreQuizScreenProps) {
  const [gender, setGender] = useState<string | null>(null);
  const [age, setAge] = useState<string | null>(null);
  const [step, setStep] = useState<'gender' | 'age'>('gender');
  const handleGenderSelect = (value: string) => {
    setGender(value);
    setTimeout(() => setStep('age'), 300);
  };
  const handleAgeSelect = (value: string) => {
    setAge(value);
    setTimeout(() => onContinue(gender!, value), 300);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex flex-col px-5 pt-5 pb-6 min-h-[100dvh] bg-white max-w-md mx-auto shadow-xl overflow-y-auto hide-scrollbar" data-id="element-227">
      {/* Header */}
      <div className="w-full bg-primary text-white py-2 px-3 rounded-xl mb-5 flex items-center justify-center gap-2" data-id="element-228">
        <User className="w-4 h-4" data-id="element-229" />
        <span className="text-xs font-black uppercase tracking-wide" data-id="element-230">
          Personalización del test
        </span>
      </div>

      <p className="text-gray-500 text-xs text-center mb-5 font-medium" data-id="element-231">
        Para darte un resultado más exacto, necesitamos saber esto.
      </p>

      {step === 'gender' && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-232">
          <div className="flex items-center gap-2 mb-4" data-id="element-233">
            <User className="w-5 h-5 text-primary" data-id="element-234" />
            <h2 className="text-xl font-black text-dark" data-id="element-235">¿Cuál es tu sexo?</h2>
          </div>

          <div className="flex flex-col gap-3" data-id="element-236">
            {GENDER_OPTIONS.map(option => <motion.button key={option.value} whileTap={{
          scale: 0.97
        }} onClick={() => handleGenderSelect(option.value)} className={`w-full text-left px-4 py-4 rounded-xl border-2 transition-all flex items-center gap-3 ${gender === option.value ? 'border-primary bg-green-50 shadow-md' : 'border-gray-200 bg-white active:border-primary active:bg-green-50'}`} data-id="element-237">
                <span className="text-2xl" data-id="element-238">{option.emoji}</span>
                <span className="text-base font-bold text-dark" data-id="element-239">
                  {option.label}
                </span>
                {gender === option.value && <motion.span initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} className="ml-auto text-primary font-black" data-id="element-240">
                    ✓
                  </motion.span>}
              </motion.button>)}
          </div>

          <div className="mt-6 bg-dark rounded-xl p-3" data-id="element-241">
            <p className="text-xs text-gray-300 font-medium text-center leading-relaxed" data-id="element-242">
              Tu metabolismo funciona diferente según tu sexo biológico. Esto
              nos ayuda a darte un diagnóstico{' '}
              <span className="text-yellow-400 font-bold" data-id="element-243">más preciso</span>.
            </p>
          </div>
        </motion.div>}

      {step === 'age' && <motion.div initial={{
      opacity: 0,
      x: 20
    }} animate={{
      opacity: 1,
      x: 0
    }} data-id="element-244">
          <div className="flex items-center gap-2 mb-4" data-id="element-245">
            <Calendar className="w-5 h-5 text-primary" data-id="element-246" />
            <h2 className="text-xl font-black text-dark" data-id="element-247">
              ¿Cuál es tu rango de edad?
            </h2>
          </div>

          <div className="flex flex-col gap-3" data-id="element-248">
            {AGE_RANGES.map(range => <motion.button key={range} whileTap={{
          scale: 0.97
        }} onClick={() => handleAgeSelect(range)} className={`w-full text-left px-4 py-4 rounded-xl border-2 transition-all flex items-center gap-3 ${age === range ? 'border-primary bg-green-50 shadow-md' : 'border-gray-200 bg-white active:border-primary active:bg-green-50'}`} data-id="element-249">
                <span className="text-base font-bold text-dark" data-id="element-250">
                  {range} años
                </span>
                {age === range && <motion.span initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} className="ml-auto text-primary font-black" data-id="element-251">
                    ✓
                  </motion.span>}
              </motion.button>)}
          </div>

          <div className="mt-6 bg-dark rounded-xl p-3" data-id="element-252">
            <p className="text-xs text-gray-300 font-medium text-center leading-relaxed" data-id="element-253">
              Tu edad afecta directamente cómo tu metabolismo procesa los
              alimentos. A partir de los 30, el metabolismo cambia{' '}
              <span className="text-red-400 font-bold" data-id="element-254">drásticamente</span>.
            </p>
          </div>
        </motion.div>}
    </motion.div>;
}